import { TableCols } from "../interfaces/static-data";

export const TRADING_CALENDARS: TableCols[] = [
  {
    key: 'calendarCode',
    displayValue: 'Calendar Code',
  },
  {
    key: 'date',
    displayValue: 'Date',
    mask: '0000-00-00',
    type: 'date'
  },
  {
    key: 'description',
    displayValue: 'Description',
  },
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  }
];
